import { render, staticRenderFns } from "./MeusDados.vue?vue&type=template&id=5c9d0522"
import script from "./MeusDados.vue?vue&type=script&lang=js"
export * from "./MeusDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports